import React from 'react'
import NAV from '../../homepage/nav/Nav';
import FREEC from './Freec';
import FOOTER from '../../homepage/footer/Footer';






const Viewcourses = ({show,setShow}) => {
    
    // setShow(homeg)

  return (
    <div>
        <NAV show={show}/>
        <FREEC/>
        <FOOTER/>
      
    </div>
  )
}

export default Viewcourses
